<div class="wrapper-reponsive">
    <!-- Start màn 11 -->
    <div class="tlt-green-row mt-3">
        {{'STR_MEDICAL_EXAM_RESERVATION' | translate}}
    </div>
    <div class="content-box mt-2 mb-3 p-3" *ngIf="typeMode === 1">
        <div class="process-step">
            <p>Step</p>
            <ul>
                <li class="active">
                    <div class="circle">
                        <span class="num">1</span>
                    </div>
                </li>
                <li class="active">
                    <div class="circle">
                        <span class="num">2</span>
                    </div>
                </li>
                <li class="active">
                    <div class="circle">
                        <span class="num">3</span>
                    </div>
                </li>
                <li class="active">
                    <div class="circle">
                        <span class="num">4</span>
                    </div>
                </li>
                <li class="active">
                    <div class="circle">
                        <span class="num">5</span>
                    </div>
                </li>
                <li class="active">
                    <div class="circle">
                        <span class="num">6</span>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="content-box mt-2 mb-4 content-box-detail">
        <div class="tlt-border mb-3">
            {{'STR_BOOKING_CONFIRMATION' | translate}}
        </div>
        <p class="p-2">
            {{'STR_EXPLAIN_BOOKING_CONFIRMATION_1' | translate}} <br>
            <span *ngIf="typeMode !== 3">{{'STR_EXPLAIN_BOOKING_CONFIRMATION_2' | translate}}<br></span>
            <br>
            {{'STR_PRICE_NOTE' | translate}}
        </p>
        <div class="box-common mb-2">
            <div class="tlt-dot m-0">
                {{'STR_RSV_DATETIME' | translate}}
                <button class="btn mark-right green" (click)="EditRsvDateTime()"
                    *ngIf="typeMode !== 3">{{'STR_BTN_EDIT_CONTENT' | translate}}</button>
            </div>
            <ul class="lst-item-border">
                <li>
                    <p class="tlt"> 【{{'STR_RSV_DAY' | translate}}】 </p>
                    <div class="desc">
                        <span>{{objRsvDateTime.RsvYMD | dateFormatLanguage : true}}</span>
                    </div>
                </li>
                <li>
                    <p class="tlt">【{{'STR_RESERVATION_TIME' | translate}}】</p>
                    <div class="desc">
                        <span>{{objRsvDateTime.RsvTime | TimePipe}}</span>
                    </div>
                </li>
            </ul>
        </div>
        <div class="box-common mb-2">
            <div class="tlt-dot m-0">
                {{'STR_COURSE_OPTION_EXAM' | translate}}
                <button class="btn mark-right green" (click)="EditCourseOption()"
                    *ngIf="typeMode !== 3">{{'STR_BTN_EDIT_CONTENT' | translate}}</button>
            </div>
            <ul class="lst-item-border">
                <li>
                    <p class="tlt"> 【{{'STR_COURSE' | translate}}】 </p>
                    <div class="desc">
                        <span>{{objCourse.HTCourseName}}</span>
                        <span>{{convertPrice(objCourse.PersonalReqPrice)}} {{'STR_MONEY_UNIT' | translate}}</span>
                    </div>
                </li>
                <li>
                    <p class="tlt"> 【{{'STR_OPTION' | translate}}】 </p>
                    <div class="desc" *ngFor="let item of objCourse?.ListOption; let k = index">
                        <span>{{item.HTOptionName}}</span>
                        <span>{{convertPrice(item.PersonalReqPrice)}} {{'STR_MONEY_UNIT' | translate}}</span>
                    </div>
                    <div class="desc" *ngFor="let item of lstSetItemCancel; let k = index">
                        <span class="text-red">{{item.HTSetItemName}}</span>
                        <span class="text-red">{{convertPriceItemCancel(item.PersonalCutPrice)}} {{'STR_MONEY_UNIT' | translate}}</span>
                    </div>
                    <span class="desc"
                        *ngIf="(this.util.isNullOrEmpty(objCourse?.ListOption) || objCourse?.ListOption?.length === 0) && lstSetItemCancel?.length === 0">{{'STR_NONE'
                        | translate}}</span>
                </li>
                <li>
                    <p class="tlt"> 【{{'STR_FEE_FRAME_TITLE' | translate}}】 </p>
                    <div class="desc">
                        <span></span>
                        <span>{{convertPrice(objCourse.TotalPrice)}} {{'STR_MONEY_UNIT' | translate}}</span>
                    </div>
                    <div>
                        <p *ngIf="CorrectAmount > 0" class="exceed-price-note">{{trans.instant('STR_EXCEED_PRICE_NOTE').replace('{0}', convertPrice(CorrectAmount))}}</p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="box-common mb-2">
            <div class="tlt-dot m-0">
                {{'STR_EXAMINEE_INF' | translate}}
                <button class="btn mark-right green" (click)="EditPersonInfo()"
                    *ngIf="typeMode !== 3">{{'STR_BTN_EDIT_CONTENT' | translate}}</button>
            </div>
            <ul class="lst-item-border">
                <li>
                    <p class="tlt">【{{'STR_NAME' | translate}}】 </p>
                    <div class="desc">
                        <span>{{objUser.ConsulName}}</span>
                    </div>
                </li>
                <li *ngIf="isShowKanaName">
                    <p class="tlt">【{{'STR_KANA_NAME' | translate}}】 </p>
                    <div class="desc">
                        <span>{{objUser.KanaName}}</span>
                    </div>
                </li>
                <li>
                    <p class="tlt">【{{'STR_DATEOFBIRTH' | translate}}】</p>
                    <div class="desc">
                        <span>{{objUser.DateOfBirth | dateFormatLanguage}}</span>
                    </div>
                </li>
                <li>
                    <p class="tlt">【{{'STR_GENDER' | translate}}】 </p>
                    <div class="desc">
                        <span *ngIf="objUser.Gender === '1'">{{'STR_GENDER_MALE' | translate}}</span>
                        <span *ngIf="objUser.Gender === '2'">{{'STR_GENDER_FEMALE' | translate}}</span>
                    </div>
                </li>
                <li>
                    <p class="tlt">【{{'STR_PHONENUM' | translate}}】 </p>
                    <div class="desc">
                        <span>{{objUser.PhoneNum | phoneNumberFormat}}</span>
                    </div>
                </li>
                <li>
                    <p class="tlt">【{{'STR_ADDRESS' | translate}}】</p>
                    <div class="desc">
                        <span>〒{{objUser.PostalCode | postalCodeFormat}}</span>
                    </div>
                    <div class="desc">
                        <span>{{objUser.Adress1}} {{objUser.Adress2}}</span>
                    </div>
                </li>
                <li>
                    <p class="tlt">【{{'STR_EMAIL_ADDRESS' | translate}}】</p>
                    <div class="desc">
                        <span>{{objUser.MailAdress}}</span>
                    </div>
                </li>
                <li>
                    <p class="tlt">【{{'STR_REQUEST_NOTE' | translate}}】</p>
                    <div class="desc">
                        <p class="mb-0" [innerHTML]="objUser.WebRsvNote | safeHtml"></p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="box-common mb-2" *ngIf="isShowInsurence">
            <div class="tlt-dot m-0">
                {{'STR_INSURANCE_INFORMATION' | translate}}
                <button class="btn mark-right green" (click)="EditInsuranceInfo()"
                    *ngIf="typeMode !== 3">{{'STR_BTN_EDIT_CONTENT' | translate}}</button>
            </div>
            <ul class="lst-item-border">
                <li>
                    <p class="tlt">【{{'STR_INSURER_NUM2' | translate }}】 </p>
                    <div class="desc">
                        <span>{{objRsv.InsurerNum}}</span>
                    </div>
                </li>
                <li>
                    <p class="tlt">【{{'STR_INSURANCE_CARD_SIGN' | translate}}】</p>
                    <div class="desc">
                        <span>{{objRsv.InsuranceCardSign}}</span>
                    </div>
                </li>
                <li>
                    <p class="tlt">【{{'STR_INSURANCE_CARDNUM' | translate}}】</p>
                    <div class="desc">
                        <span>{{objRsv.InsuranceCardNum}}</span>
                    </div>
                </li>
                <li>
                    <p class="tlt">【{{'STR_INSURANCE_CARD_BRANCHNUM' | translate}}】</p>
                    <div class="desc">
                        <span>{{objRsv.InsuranceCardBranchNum}}</span>
                    </div>
                </li>
                <li>
                    <p class="tlt">【{{'STR_PERSONAL_FAMILY_DIV' | translate}}】</p>
                    <div class="desc">
                        <span *ngIf="objRsv.PersonFamilyDiv === '1'">{{'STR_PERSON' | translate}}</span>
                        <span *ngIf="objRsv.PersonFamilyDiv === '2'">{{'STR_FAMILY' | translate}}</span>
                    </div>
                </li>
            </ul>
        </div>
        <div class="row-input row-input-auto-height p-4 mb-2">
            <div class="pl-3">
                <div class="tlt-dot mb-1">{{'STR_WEB_RSV_AGREEMENT' | translate}}
                    <div class="mark-right" *ngIf="typeMode === 1">{{'STR_REQUIRED' | translate}}</div>
                </div>
                <p class="p-2 mb-0" *ngIf="typeMode === 1">
                    {{'STR_EXPLAIN_INSURANCE_INFORMATION' | translate}}
                </p>
                <a href="/booking-terms" target="_blank">
                    <strong>{{'STR_BOOKING_TERMS' | translate}}</strong>
                </a>
                <div class="mt-2" *ngIf="typeMode === 1">
                    <label class="custom-checkbox">
                        {{'STR_AGREE_BOOKING_TERMS' | translate}}
                        <input type="checkbox" [(ngModel)]="isAgree" (change)="changeAgree()">
                        <span class="checkmark"></span>
                    </label>
                </div>
                <span class="text-error" *ngIf="isMessAgree && typeMode === 1">{{'MESS_ERR_RULE_ISNOT_AGREED' |
                    translate}}</span>
            </div>
        </div>
        <div class="text-center mt-4">
            <div class="lst-button-flex">
                <button class="btn btn-common btn-bg-yellow mr-2 ml-2 mb-2" (click)="ButtonBack()"
                    *ngIf="typeMode !== 1">
                    {{'STR_BTN_BACK' | translate}}
                </button>
                <button class="btn btn-common btn-bg-red mr-2 ml-2 mb-2" *ngIf="typeMode !== 3"
                    (click)="ButtonCancelRsv()">
                    {{'STR_RSV_CANCEL_BTN' | translate}}
                </button>
                <button class="btn btn-common btn-bg-green mr-2 ml-2 mb-2" (click)="ButtonRegis()"
                    *ngIf="typeMode !== 3" [disabled]="typeMode === 2 && !checkDataChange()">
                    {{'STR_MENU_RESERV_REGIS' | translate}}
                </button>
            </div>
        </div>
    </div>
    <!-- End màn 11 -->
</div>